import { useNavigate } from 'react-router-dom';

import { Button } from '@/components/ui/button';

export default function NotFound() {
  const navigate = useNavigate();
  return (
    <div className="flex min-h-dvh flex-col items-center justify-center bg-background px-4 py-6 text-center">
      <p className="m-0 font-heading text-[64px] font-bold text-muted-foreground/40">404</p>
      <h1 className="mt-2 mb-3 font-heading text-2xl font-bold text-foreground">
        Page not found.
      </h1>
      <p className="mb-8 font-body text-15 text-muted-foreground">
        The page you are looking for does not exist.
      </p>
      <Button size="lg" onClick={() => navigate('/dashboard')}>
        Go to Dashboard
      </Button>
    </div>
  );
}
